export class UnviewedMessageByConversation {
  constructor(
    public readonly idConversation: number,
    public readonly countUnviewed: number,
  ) {}
}
